import styled from 'styled-components';
import { BaseTagStyles } from './styles/baseTagStyles';

export interface ManufacturerApprovedProps {
  manufacturer: string;
}

const Tag = styled.div<any>`
  ${BaseTagStyles};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  background: ${({ theme }) => theme.colors.GREY_LIGHTER};
`;

const Approved = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const Divider = styled.div`
  width: 1px;
  height: 12px;
  margin: 0 ${({ theme }) => theme.spacing.S8};
  background-color: ${({ theme }) => theme.colors.GREY_DARK};
`;

function ManufacturerApproved({ manufacturer }: ManufacturerApprovedProps) {
  return (
    <Tag>
      {manufacturer}
      <Divider />
      <Approved>Approved</Approved>
    </Tag>
  );
}

export { ManufacturerApproved };
